var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationPinRed40(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    width: 40,
    height: 40,
    fill: "#ff3b30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 40,
    height: 40
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 3C13.924 3 9 7.924 9 14c0 2.65.76 5.155 2.14 7.405 1.44 2.34 3.33 4.35 4.79 6.69.71 1.14 1.22 2.21 1.76 3.41.4.88.74 2.1 2.31 2.1s1.91-1.22 2.31-2.1c.54-1.2 1.05-2.27 1.76-3.41 1.46-2.34 3.35-4.35 4.79-6.69C30.24 19.155 31 16.65 31 14c0-6.076-4.924-11-11-11zm0 13.5a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPinRed40);
export default __webpack_public_path__ + "static/media/location_pin_red_40.2dfa44f11cfcf37b276c933ef0f78d56.svg";
export { ForwardRef as ReactComponent };